import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class UserDiscardedAdsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  addDiscardedAd() {
    throw new Error('[UserDiscardedAds#addDiscardedAd] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getDiscardedAds() {
    throw new Error('[UserDiscardedAds#getDiscardedAds] must be implemented')
  }
}
